// Date utility functions for DOB format conversion

export const isoToDisplay = (iso) => {
  if (!iso) return '';
  
  try {
    const date = new Date(iso);
    return date.toLocaleDateString('en-GB');
  } catch (error) {
    console.error('Error converting ISO date to display format:', error);
    return '';
  }
};

export const displayToISO = (ddmmyyyy) => {
  if (!ddmmyyyy) return '';
  
  try {
    const parts = ddmmyyyy.split('/');
    if (parts.length !== 3) return '';
    
    const [d, m, y] = parts;
    
    // Validate parts
    const day = parseInt(d, 10);
    const month = parseInt(m, 10);
    const year = parseInt(y, 10);
    
    if (isNaN(day) || isNaN(month) || isNaN(year)) return '';
    if (day < 1 || day > 31) return '';
    if (month < 1 || month > 12) return '';
    if (year < 1900 || year > new Date().getFullYear()) return '';
    
    // Format as ISO string (YYYY-MM-DD)
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  } catch (error) {
    console.error('Error converting display date to ISO format:', error);
    return '';
  }
};

export const isoToLocalDateTime = (iso) => {
  if (!iso) return '';

  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    const offsetMinutes = date.getTimezoneOffset();
    const localTime = new Date(date.getTime() - offsetMinutes * 60000);
    return localTime.toISOString().slice(0, 16);
  } catch (error) {
    console.error('Error converting ISO datetime to local input format:', error);
    return '';
  }
};

export const localDateTimeToISO = (value) => {
  if (!value) return '';

  try {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    return date.toISOString();
  } catch (error) {
    console.error('Error converting local datetime to ISO format:', error);
    return '';
  }
};